module.exports = __webpack_public_path__ + "static/media/thinking.2f681bef.gif";